import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-scroll"; // Import react-scroll for smooth scrolling
import logo from "../assets/logo.png";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    if (menuRef.current) {
      if (isMenuOpen) {
        menuRef.current.style.maxHeight = `${menuRef.current.scrollHeight}px`;
        menuRef.current.style.opacity = "1";
      } else {
        menuRef.current.style.maxHeight = "0";
        menuRef.current.style.opacity = "0";
      }
    }
  }, [isMenuOpen]);

  return (
    <div className="z-50 fixed w-full flex justify-between items-center bg-header px-10">
      {/* Logo */}
      <div className="flex items-center gap-10 lg:gap-14 sm:ml-5 lg:ml-10">
        
        <Link
            to="home"
            duration={500}
            offset={-70} // Adjust offset based on navbar height
            className="cursor-pointer"
          >
            <img className="w-14 pt-2 pb-3" src={logo} alt="logo" />
          </Link>
        {/* Desktop Menu */}
        <div className="hidden md:flex gap-5 lg:gap-10 lg:text-lg text-white font-sans font-semibold">
          <Link
            to="home"
            duration={500}
            offset={-70} // Adjust offset based on navbar height
            className="cursor-pointer hover:scale-110 hover:underline transition-all duration-300"
          >
            Home
          </Link>
          <Link
            to="about"
            duration={500}
            offset={-70}
            className="cursor-pointer hover:scale-110 hover:underline transition-all duration-300"
          >
            About Us
          </Link>
          <Link
            to="why-us"
            duration={500}
            offset={-70}
            className="cursor-pointer hover:scale-110 hover:underline transition-all duration-300"
          >
            Why Us
          </Link>
          <Link
            to="testimonial"
            duration={500}
            offset={-70}
            className="cursor-pointer hover:scale-110 hover:underline transition-all duration-300"
          >
            Testimonial
          </Link>
          <Link
            to="faqs"
            duration={500}
            offset={-70}
            className="cursor-pointer hover:scale-110 hover:underline transition-all duration-300"
          >
            FAQ's
          </Link>
        </div>
      </div>

      {/* Burger Icon */}
      <button
        onClick={toggleMenu}
        className="md:hidden text-white text-2xl focus:outline-none"
      >
        {isMenuOpen ? "×" : "☰"}
      </button>

      {/* Mobile Menu */}
      <div
        ref={menuRef}
        className={`md:hidden absolute top-[77px] left-0 w-full bg-themeColor text-white font-yeseva flex flex-col items-center  transition-all duration-500 overflow-hidden max-h-0 opacity-0`}
        style={{ transition: "max-height 0.5s ease, opacity 0.5s ease" }}
      >
        <Link
          to="home"
          duration={500}
          offset={-70}
          className="py-[4px] hover:scale-110 hover:underline transition-all duration-300 pt-5"
          onClick={toggleMenu} // Close menu on click
        >
          Home
        </Link>
        <Link
          to="about"
          duration={500}
          offset={-70}
          className="py-[4px] hover:scale-110 hover:underline transition-all duration-300"
          onClick={toggleMenu}
        >
          About Us
        </Link>
        <Link
          to="why-us"
          duration={500}
          offset={-70}
          className="py-[4px] hover:scale-110 hover:underline transition-all duration-300"
          onClick={toggleMenu}
        >
          Why Us
        </Link>
        <Link
          to="testimonial"
          duration={500}
          offset={-70}
          className="py-[4px] hover:scale-110 hover:underline transition-all duration-300"
          onClick={toggleMenu}
        >
          Testimonial
        </Link>
        <Link
          to="faqs"
          duration={500}
          offset={-70}
          className="py-[4px] hover:scale-110 hover:underline transition-all duration-300"
          onClick={toggleMenu}
        >
          FAQ's
        </Link>
        {/* Contact Us Button for Mobile Menu */}
        <div className="flex flex-col items-center font-montserrat pb-5">
          <Link
            to="contact"
            duration={500}
            offset={-70} // Adjust to the appropriate offset for the contact section
            className="cursor-pointer text-themeColor font-[550] bg-white rounded-full px-5 py-1.5 text-base hover:scale-105 transition-all duration-300"
            onClick={toggleMenu} // Close menu on click
          >
            Contact Us
          </Link>
        </div>
      </div>

      {/* Desktop Action Items */}
      <div className="hidden md:flex items-center gap-9 font-montserrat text-white">
        <Link
          to="contact"
          duration={500}
          offset={-70} // Adjust offset for contact section
          className="cursor-pointer text-themeColor font-[550] bg-white rounded-full px-5 py-1.5 text-base hover:scale-105 transition-all duration-300"
        >
          Contact Us
        </Link>
      </div>
    </div>
  );
}

export default Navbar;
